export default "__VITE_ASSET__BT6PkZM___"